import React from 'react'
import { shallow } from 'enzyme'
import { DebtSchedule } from '../DebtSchedule'
import Loader from '../../common/Loader'
import business from './testData/debtScheduleBusiness'
import DebtFooter from '../DebtFooter'

describe('<DebtSchedule />', () => {
  let wrapper, instance
  const noop = () => {}
  const props = {
    financialReviewRefetch: noop,
    data: {
      business,
      refetch: noop
    },
    monthsRemainingCutoff: 7,
    name: 'Test Biz'
  }
  const dataWithoutLoan = {
    ...props.data,
    business: {
      ...props.data.business,
      outstandingLoans: []
    }
  }
  beforeEach(() => {
    wrapper = shallow(<DebtSchedule {...props} />)
    instance = wrapper.instance()
  })
  describe('#renderHeader', () => {
    it('renders a header with the business name', () => {
      const headerWrapper = shallow(instance.renderHeader())
      expect(headerWrapper.text()).toContain(instance.props.name)
    })
  })
  describe('#toggleAddDebt', () => {
    describe('when isEditable is false', () => {
      beforeEach(() => {
        wrapper.setState({ isEditable: false })
      })
      it('changes isEditable to true', () => {
        instance.toggleAddDebt()
        expect(wrapper.state('isEditable')).toBeTruthy()
      })
    })
    describe('when isEditable is true', () => {
      beforeEach(() => {
        wrapper.setState({ isEditable: true })
      })
      it('changes isEditable to false', () => {
        instance.toggleAddDebt()
        expect(wrapper.state('isEditable')).toBeFalsy()
      })
    })
  })
  describe('#renderFooter', () => {
    describe('when there is at least one outstanding loan', () => {
      it('renders two <DebtFooter />s', () => {
        expect(wrapper.find(DebtFooter)).toHaveLength(2)
      })
    })
    describe('when there are no outstanding loans', () => {
      beforeEach(() => {
        wrapper = shallow(<DebtSchedule {...props} data={dataWithoutLoan} />)
      })
      it('should not render any footers', () => {
        expect(wrapper.find(DebtFooter)).toHaveLength(0)
      })
    })
  })
  describe('#renderNewDebt', () => {
    describe('when isEditable is true', () => {
      beforeEach(() => {
        wrapper.setState({ isEditable: true })
      })
      it('returns a DebtRow', () => {
        expect(instance.renderNewDebt()).toBeTruthy()
      })
    })
    describe('when isEditable is false', () => {
      beforeEach(() => {
        wrapper.setState({ isEditable: false })
      })
      it('returns a undefined', () => {
        expect(instance.renderNewDebt()).toBeUndefined()
      })
    })
  })
  describe('#renderRows', () => {
    describe('when there is at least one outstanding loan', () => {
      it('renders one row per outstanding loan', () => {
        const { outstandingLoans } = instance.props.data.business
        expect(instance.renderRows()).toHaveLength(outstandingLoans.length)
      })
    })
    describe('when there are no outstanding loans', () => {
      beforeEach(() => {
        wrapper = shallow(<DebtSchedule {...props} data={dataWithoutLoan} />)
        instance = wrapper.instance()
      })
      it('should not render any rows', () => {
        expect(instance.renderRows()).toHaveLength(0)
      })
    })
  })
  describe('#render', () => {
    describe('when data\'s networkStatus property is 1', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, networkStatus: 1 } })
      })
      it('should render a loader', () => {
        expect(wrapper.find(Loader)).toHaveLength(1)
      })
    })
    describe('when there is an error fetching the data', () => {
      beforeEach(() => {
        wrapper.setProps({ data: { ...props.data, error: {} } })
      })
      it('renders an error message', () => {
        expect(wrapper.find('h3')).toHaveLength(1)
      })
    })
  })
})
